import { useMemo } from "react";
import { CPServiceObject } from "../../../api/models/unified";
import { useNextRevisionHelpers } from "../../../helpers/serviceObjectHelper";
import { renderDate } from "../../../helpers/dayjsHeleprs";
import { Tooltip } from "../../../components";

interface ServiceObjectNextRevisionTooltipProps {
  serviceObject: CPServiceObject;
}

const ServiceObjectNextRevisionTooltip = ({
  serviceObject,
}: ServiceObjectNextRevisionTooltipProps) => {
  const { translateRevisionModeWithLabel, translateRevisionPeriodWithLabel } =
    useNextRevisionHelpers();

  const nearestRevision = useMemo(
    () =>
      serviceObject.revisionCategories.find(
        (x) => x.id === serviceObject.nextRevisionCategoryId,
      ),
    [serviceObject.revisionCategories, serviceObject.nextRevisionCategoryId],
  );

  if (!nearestRevision?.nextRevision || !serviceObject.nextRevisionCategoryId)
    return null;

  return (
    <Tooltip
      label={renderDate(nearestRevision.nextRevision)}
      id={`${serviceObject.id}-${serviceObject.nextRevisionCategoryId}`}
    >
      <div className="text-[14px]/[21px] font-semibold">
        {nearestRevision.name}
      </div>
      {nearestRevision.nextRevisionMode && (
        <div className="text-[13px]/[20px] font-medium">
          {translateRevisionModeWithLabel(nearestRevision.nextRevisionMode)}
        </div>
      )}
      {nearestRevision.nextRevisionPeriodValue &&
        nearestRevision.nextRevisionPeriodUnit && (
          <div className="text-[13px]/[20px]">
            {translateRevisionPeriodWithLabel(
              nearestRevision.nextRevisionPeriodValue,
              nearestRevision.nextRevisionPeriodUnit,
            )}
          </div>
        )}
    </Tooltip>
  );
};

export default ServiceObjectNextRevisionTooltip;
